import { Box} from "@mui/material";

import styles from "./SelectedAssigned.module.scss";
import i18next from "i18next";
import PropTypes from "prop-types";

const SelectedAssignedPopup = (props) => {
  const {  handleCloseButtonClick = [] } = props;
  return (
    <Box
      className={styles.selectedAssignedwraper}
      data-testid="SelectedAssignedPopup"
    >
      <Box className={styles.insidefrmelabelWrapper}>
        <Box className={styles.IconText}>
        </Box>
          <Box className={styles.labelInsideBox}>
            {i18next.t(
              "Group has beed updated for the dealers that you have selected"
            )}
          </Box>
       

        <Box className={styles.IconCrossWrapper}>
          <Box
            className={styles.IconCross}
            onClick={handleCloseButtonClick}
            onKeyDown={()=>{}}
          ></Box>
        </Box>
      </Box>
    </Box>
  );
};

export default SelectedAssignedPopup;
SelectedAssignedPopup.propTypes={
  handleCloseButtonClick:PropTypes.any
}
